import axios from "axios";
import { authenticatedHeader } from "../../DefaultConfig";
import { StatisticsURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function getSiteTopicDistribution(site: string, days: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/statistics/site/topic-distribution",
    {
      site: site,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function siteDetail(site: string) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL + "api/statistics/site/detail/" + site,
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function activeSitesToday() {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL + "api/statistics/site/active/today",
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
